import React from "react"
import {IonButton, IonIcon, IonNote} from "@ionic/react";
import {chevronForwardOutline, chevronForwardSharp} from "ionicons/icons";
import {useLockingSystems} from "../../../contexts/LockingSystemContext";
import {useTranslation} from "react-i18next";
import TimeDiffHuman from "../../common/Text/TimeDiffHuman";

interface props {
    item: any;
}

const SyncHeader: React.FC<props> = ( {item} ) => {

    const { t } = useTranslation()

    const {isSynchronizing, syncByLockingSystemId} = useLockingSystems()

    if (item.lockingSystemApi === null) {
        return <span style={ {'backgroundColor': 'red', 'borderRadius': '6px', 'color': 'white', 'padding': '10px' } }>
            Geen API instellingen gevonden, geen synchronisatie mogelijk.
        </span>
    }

    if (item.lockingSystemSyncState !== null && item.lockingSystemSyncState?.lockedAt !== null) {
        return <span style={{ 'backgroundColor': 'blue', 'borderRadius': '6px', 'color': 'white', 'padding': '10px 20px' }}>
            {t('common.sync_in_progress')}
        </span>
    }

    return <span>
        {item.lockingSystemApi?.manualSyncAll === true &&
            <IonButton color="bc-yellow"
                       disabled={isSynchronizing !== null}
                       fill="solid" type="button"
                       onClick={(ev) => {
                           ev.preventDefault()
                           ev.stopPropagation()

                           syncByLockingSystemId(item.id)
                       }}>
                {t('common.sync_all')}
                <IonIcon slot="end" ios={chevronForwardOutline} md={chevronForwardSharp} />
            </IonButton>
        }
        {(item.lockingSystemSyncState !== null && item.lockingSystemSyncState?.allSecondsAgo > 0) &&
        <IonNote className="maxWidth ion-padding-vertical">
            {t('common.last_time')}:&nbsp;
            <TimeDiffHuman maxAge={86400} seconds={item.lockingSystemSyncState?.allSecondsAgo} useColor={true} />
        </IonNote>
        }
    </span>

}

export default SyncHeader